module.exports = __webpack_public_path__ + "img/features.4ffc4d1f.webp";